import React, { createContext, useContext, useEffect, useState } from 'react';

const CustomerContext = createContext();
export const useCustomer = () => useContext(CustomerContext);

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  
  
  // Debug provider mounting/unmounting
  useEffect(() => {
    console.log('🟢 CustomerProvider mounting');
    return () => {
      console.log('🔴 CustomerProvider unmounting - this should NOT happen on navigation');
      console.trace('CustomerProvider unmount stack trace');
    };
  }, []);
  
  // Debug logging for customer changes
  useEffect(() => {
    console.log('CustomerContext: Customer changed to:', customer);
    if (!customer) {
      console.log('❌ Customer became null - checking why');
      console.trace('Customer null stack trace');
    }
  }, [customer]);

  useEffect(() => {
    console.log('🔍 CustomerProvider initial load - checking localStorage');
    const id = localStorage.getItem('customerId');
    const email = localStorage.getItem('customerEmail');
    console.log('Initial localStorage check:', { id, email });
    if (id && email) {
      console.log('✅ Setting customer from localStorage:', { id, email });
      setCustomer({ id, email });
    } else {
      console.log('⚠️ No customer data in localStorage');
    }
  }, []);
  
  // Monitor window navigation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      console.log('⚠️ BEFORE UNLOAD EVENT - Page is reloading/leaving');
      console.trace('Before unload stack trace');
    };
    
    const handlePopState = (e) => {
      console.log('⚠️ POPSTATE EVENT - Browser back/forward navigation');
      console.log('New location:', window.location.pathname);
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  
  // Monitor localStorage changes
  useEffect(() => {
    const originalSetItem = localStorage.setItem;
    const originalRemoveItem = localStorage.removeItem;
    const originalClear = localStorage.clear;
    
    localStorage.setItem = function(key, value) {
      if (key === 'customerId' || key === 'customerEmail') {
        console.log(`💾 localStorage.setItem('${key}', '${value}')`);
        console.trace('localStorage.setItem stack trace');
      }
      return originalSetItem.call(this, key, value);
    };
    
    localStorage.removeItem = function(key) {
      if (key === 'customerId' || key === 'customerEmail') {
        console.log(`🗑️ localStorage.removeItem('${key}')`);
        console.trace('localStorage.removeItem stack trace');
      }
      return originalRemoveItem.call(this, key);
    };
    
    localStorage.clear = function() {
      console.log('🚨 localStorage.clear() called!');
      console.trace('localStorage.clear stack trace');
      return originalClear.call(this);
    };
    
    return () => {
      localStorage.setItem = originalSetItem;
      localStorage.removeItem = originalRemoveItem;
      localStorage.clear = originalClear;
    };
  }, []);

  const loadCustomer = (id, email) => {
    // Ensure ID is stored as string
    const idStr = id?.toString() || '';
    localStorage.setItem('customerId', idStr);
    localStorage.setItem('customerEmail', email || '');
    setCustomer({ id: idStr, email });
  };

  const clearCustomer = () => {
    localStorage.removeItem('customerId');
    localStorage.removeItem('customerEmail');
    localStorage.removeItem('priceData'); // optional, but matches your intent
    setCustomer(null);
  };

  return (
    <CustomerContext.Provider value={{ customer, loadCustomer, clearCustomer }}>
      {children}
    </CustomerContext.Provider>
  );
};
